import { component } from 'picoapp'
import { updateItemById } from '@/lib/cart.js'
import { formatMoney } from '@/lib/currency.js'
import app from '@/app.js'

class Cart {
  constructor(node, ctx) {
    // bindings
    this.onCloseClick = this.onCloseClick.bind(this)
    this.onOnItemClick = this.onOnItemClick.bind(this)
    this.onCartUpdated = this.onCartUpdated.bind(this)

    // selectors
    this._node = node
    this._items = document.getElementById('cart-items')
    this._error = document.getElementById('cart-error')
    this._status = document.getElementById('cart-status')
    this._subtotal = document.getElementById('cart-subtotal')
    this._close = document.getElementById('cart-close-btn')

    // privates
    this._ctx = ctx
    this._locked = false

    // events
    this._items.addEventListener('click', this.onOnItemClick, false)
    this._ctx.on('cart:updated', this.onCartUpdated)
    this._close.addEventListener('click', this.onCloseClick, false)

    // render
    this.render(this._ctx.getState().cart)

    // unmount
    this.unmount.bind(this);
  }

  /**
   * Handle close click.
   */
  onCloseClick() {
    this.showCartError('')
    this._ctx.emit('cart:toggle', (state) => {
      return {
        cartOpen: false
      }
    })
  }

  /**
   * Handle item click.
   * Delegation for decrease, increase and remove.
   */
  onOnItemClick(e) {
    if (this._locked) return
    else this._locked = true

    this.showCartError('')


    let el = e.target,
        cl = el.classList

    if (cl.contains('decrease-item') || cl.contains('increase-item') || cl.contains('remove-item')) {
      let id = el.parentNode.parentNode.parentNode.parentNode.getAttribute('data-item'),
          quantity = parseInt(el.parentNode.parentNode.parentNode.parentNode.getAttribute('data-quantity'), 10)

      if (cl.contains('decrease-item') || cl.contains('increase-item')) {
        quantity = cl.contains('decrease-item') ? quantity - 1 : quantity + 1
      } else {
        quantity = 0
      }

      Promise.all([
        updateItemById(id, quantity)
      ]).then(([{item, cart}]) => {
        this._locked = false
      }).catch((error) => {
        this.showCartError(error)
        this._locked = false
      })
    }
  }

  /**
   * Show a cart error.
   */
  showCartError(error) {
    if (error === '') {
      this._error.style.display = 'none'
    } else {
      this._error.style.display = 'block'
    }

    this._error.innerText = `<strong>${error}</strong>`;
  }

  /**
   * Render an item.
   */
  renderItem(item) {
    let preorder = false,
        prefix = preorder ? `<span class='red'>PREORDER</span><br>` : '',
        item_title = item.title,
        item_title_no_price = item_title.split(/(\s-\s\$)/)[0],
        price = formatMoney(item.price).replace(".00", ""),
        prices = price;

    if (item.discounts.length >= 1 && item.discounted_price < item.price) {
      let discount_price = formatMoney(item.discounted_price).replace(".00", "");
      prices = `<span class="strike">${price}</span><span>${discount_price}</span>`
    }

    return `
      <div class="cart-item pad-ts pad-bs" data-item="${item.key}" data-quantity="${item.quantity}">
        <div class="cart-item-card">
          <a class="thumb" href="${item.url}">
            <img src="${item.image.replace(/(\.gif|\.jpg|\.png)/i, '_300x$1')}">
          </a>
        </div>
        <div class="cart-item-details">
          <p class="fs-small"><a href="${item.url}"><strong>${prefix}${item_title_no_price}</strong></a><strong class="price">${prices}</strong></p>
          <div class="calc-zone">
            <div class="quantity-box fs-qty red">
              <div class="decrease-item"></div>
              <div class="quantity-item fs-small"><strong>${item.quantity}</strong></div>
              <div class="increase-item"></div>
            </div>
          </div>
        </div>
      </div>
    `
  }

  /**
   * Re-render.
   */
  render(cart) {
    let items = cart.items.map((item) => this.renderItem(item)),
        item_count = items.length,
        status_text = 'YOUR CART IS EMPTY'

    if (item_count > 0) {
      this._node.classList.remove('empty-cart')
      status_text = item_count > 1 ? `${item_count} ITEMS IN YOUR CART` : `${item_count} ITEM IN YOUR CART`

      let preorder = false,
          prefix = preorder ? `<span class='red'>PREORDER </span>` : '',
          discount_rows = this._node.querySelector('.discount-rows'),
          discount_html = '';

      if (cart.cart_level_discount_applications.length > 0) {
        cart.cart_level_discount_applications.forEach((item, i) => {
          let discount_value = (item.total_allocated_amount / 100).toFixed(2).replace(".00", "")
          discount_html += `<div class="discount-row red fs-small"><p><strong>${prefix} ${item.title}</strong></p><p><strong>-$${discount_value}</strong></p></div>`
        })

        discount_rows.innerHTML = discount_html
      }
    } else {
      this._node.classList.add('empty-cart')
    }

    this._status.innerHTML = `<strong>${status_text}</strong>`

    this._items.innerHTML = items.join('')
    this._subtotal.innerText = formatMoney(cart.total_price).replace(".00", "")
  }

  /**
   * Handle cart updated.
   */
  onCartUpdated(state) {
    this.showCartError('')
    this.render(state.cart)
  }

  /**
   * Handle unmount.
   */
  unmount() {
    this._items.removeEventListener('click', this.onOnItemClick, false)
    this._ctx.on('cart:updated', this.onCartUpdated)
    this._close.removeEventListener('click', this.onCloseClick, false)
  }
}

export default component((node, ctx) => new Cart(node, ctx))
